import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ScriptLoaderService} from '../../_services/script-loader.service';
import {AuxilioService} from "../../entidades/auxilio/auxilio.service";
import {Auxilio} from "../../entidades/auxilio/auxilio";
import {FilterDataHql} from "../../shared/filterdata/filter-data-hql";
import * as moment from "moment";
import {ColumnType} from "../../shared/filterdata/column-type.enum";
import {ColumnMatch} from "../../shared/filterdata/column-match.enum";
import {Subject} from "rxjs";
import {Associado} from "../../entidades/associado/associado";

declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit, AfterViewInit {

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<Auxilio> = new Subject();

  dataList: Array<Auxilio> = [];
  auxilios: Array<Auxilio> = [];
  viewType: string = 'HOJE';

  tipoAuxilio: string = '-1';

  constructor(public auxilioService: AuxilioService, private _script: ScriptLoaderService) { }

  ngOnInit() {
    this.dtTrigger = new Subject<Auxilio>();
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 5,
      language: {
        emptyTable: "Nenhum registro encontrado",
        info: "Mostrando de _START_ até _END_ de _TOTAL_ registros",
        infoEmpty: "Mostrando 0 até 0 de 0 registros",
        infoFiltered: "(Filtrados de _MAX_ registros)",
        infoPostFix: "",
        thousands: ".",
        lengthMenu: "_MENU_ resultados por página",
        loadingRecords: "Carregando...",
        processing: "Processando...",
        zeroRecords: "Nenhum registro encontrado",
        search: "Pesquisar",
        paginate: {
          next: "Próximo",
          previous: "Anterior",
          first: "Primeiro",
          last: "Último"
        },
        aria: {
          sortAscending: ": Ordenar colunas de forma ascendente",
          sortDescending: ": Ordenar colunas de forma descendente"
        }
      }
    };
    this.dtTrigger.next();
    this.loadTodayContent();
  }

  ngAfterViewInit() {
    this._script.load('./assets/js/scripts/widgets.js').then();
    // this._script.load('./assets/js/scripts/dashboard_visitors.js');
  }

  loadTodayContent() {
    this.auxilioService.loadByFilterHql({whereClauses: [{columnName: 'dataContrato', iniValue: moment().format('YYYY-MM-DD'), columnType: ColumnType.DATE, columnMatch: ColumnMatch.EQUALS}]} as FilterDataHql).subscribe(response => {
      if(response.success) {
        //console.log(response.content);
        this.dataList = response.content;
        this.auxilios = this.dataList;
        this.viewType = 'HOJE';
        //this.dtTrigger.next();
      }

    }, e => console.log(e.message));
  }

  loadMonthContent() {
    let dateIni = new Date().getFullYear() + '-' + new Date().getMonth() + '-01';
    let dateEnd = new Date().getFullYear() + '-' + new Date().getMonth() + '-31';

    this.auxilioService.loadByFilterHql({whereClauses: [{columnName: 'dataContrato', iniValue: dateIni, endValue: dateEnd, columnType: ColumnType.DATE, columnMatch: ColumnMatch.BETWEEN}]} as FilterDataHql).subscribe(response => {
      if(response.success) {
        console.log(response.content);
        this.dataList = response.content;
        this.auxilios = this.dataList;
        this.viewType = 'MES';
      }

    }, e => console.log(e.message));
  }

  getAuxilios() {
    return this.auxilios;
  }

  getTotalEmprestado(): number {
    let result = 0.00;
    if (this.auxilios.length > 0) {
      this.auxilios.forEach(a => { result += (a.vlrparcelas * a.qtdparcelas); });
    }

    return result;
  }

  getTotalLiberado(): number {
    let result = 0.00;
    if (this.auxilios.length > 0) {
      this.auxilios.forEach(a => { result += a.vlrauxilio; });
    }

    return result;
  }

  getTotalParcelados(): number {
    let result = 0.00;
    if (this.auxilios.length > 0) {
      this.auxilios.forEach(a => { result += (a.vlrparcelas * a.qtdparcelas); });
    }

    return result;
  }

  getTotalMensalidade(): number {
    let result = 0.00;
    if (this.auxilios.length > 0) {
      this.auxilios.forEach(a => { result += a.qtdparcelas * 79.00; });
    }

    return result;
  }

  onClickNovaProposta() {
    alert("EM CONSTRUÇÂO");
  }

  onClickRowTable() {
    alert("EM CONSTRUÇÂO");
  }

  onSelectTipo() {
    if (this.tipoAuxilio != '-1') {
      this.auxilios = this.dataList.filter(a => a.tipo === this.tipoAuxilio).sort((a1, a2) => a1.dataContrato.toLocaleString() > a2.dataContrato.toLocaleString() ? 1 : -1);
    } else {
      this.auxilios = this.dataList.sort((a1, a2) => a1.dataContrato.toLocaleString() > a2.dataContrato.toLocaleString() ? 1 : -1);
    }
  }
}
